import { LoaderParser, ExtensionMetadata, ExtensionType, LoaderParserPriority, checkExtension, ResolvedAsset, Loader } from "pixi.js";
import { PromiseCompletionSource } from "scene-manager";
import { Mesh } from "three";
import { Font, FontLoader } from "three/examples/jsm/loaders/FontLoader.js";

export class ThreeFontLoader implements LoaderParser<Font> {
    public readonly name: string;
    public readonly extension: ExtensionMetadata;
    private readonly loader: FontLoader;

    public constructor() {
        this.name = "three_js_font_loader";
        this.extension = {
            type: ExtensionType.LoadParser,
            priority: LoaderParserPriority.High
        };
        this.loader = new FontLoader();
    }

    public test(url: string): boolean {
        return checkExtension(url, ".fontjson");
    }

    public async load<T>(url: string, _resolvedAsset?: ResolvedAsset<Record<string, any>>, _loader?: Loader): Promise<T> {
        const pcs = new PromiseCompletionSource<Font>();
        this.loader.load(
            url,
            (result: Font) => pcs.complete(result),
            null,
            (reason: unknown) => pcs.error(reason)
        );
        const result = await pcs.result as T;
        return result;
    }

    public unload(asset: Font, resolvedAsset?: ResolvedAsset<any>, loader?: Loader) {
        if(!(asset instanceof Mesh)) {
            return;
        }

        asset.geometry.dispose();
        if(Array.isArray(asset.material)) {
            for(const material of asset.material) {
                material.dispose();
            }
        } else {
            asset.material.dispose();
            
        }
        for(const texture of asset.material.textures) {
            texture.dispose();
        }
    }
}